import { Component, OnInit, output, signal, viewChild, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputIconModule } from 'primeng/inputicon';
import { IAddRequestOptions } from 'src/app/interface/add-request-options.interface';
import { requestOptions } from './add-request-options.config';
import { AddCollabComponent } from 'src/app/views/collabs/add-collab/add-collab.component';
import { DialogModule } from 'primeng/dialog';
import { BookingsFlowPopupComponent } from '../bookings-flow-popup/bookings-flow-popup.component';
import { PrimeListComponent } from 'src/app/views/prime/prime-list/prime-list.component';
import { AddTodoTasksPopupComponent } from 'src/app/views/collabs/collab-overview/todo-tasks-popup/todo-tasks-popup.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ReminderCreateComponent } from 'src/app/views/reminders/create/reminder-create.component';
import { MeetupCreateComponent } from 'src/app/views/meetup/create/meetup-create.component';
import { PaymentFlowPopupComponent } from '../payment-flow-popup/payment-flow-popup.component';
import { PaHttpClient } from 'src/app/clients/http-client';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { ToastrService } from 'src/app/shared/services/toastr.service';
import { WorkspaceMetricsService } from 'src/app/shared/services/workspace-metrics.service';
import { ThankyouPopupComponent } from 'src/app/shared/components/thankyou-popup/thankyou-popup.component';
import { CreateRequestPopupComponent } from "src/app/views/requests/create/requests-create.component";
import { AddContactPopupComponent } from 'src/app/views/contacts/add-contact-popup/add-contact-popup.component';
import { AmenitiesCreateComponent } from "src/app/views/amenities/create-amenities/amenities-create.component";
import { GuestsEntryCreateComponent } from "src/app/views/guests-entry/create-guests-entry/guests-entry-create.component";
import { getApiErrorMessage } from 'src/app/shared/utils/api-error.util';
import { FrontdeskRequestsCreateComponent } from "src/app/views/frontdesk-requests/create-frontdesk-requests/frontdesk-requests-create.component";

@Component({
  selector: 'pa-add-request-popup',
  imports: [
    CommonModule,
    FormsModule,
    InputIconModule,
    DialogModule,
    PaymentFlowPopupComponent,
    AddCollabComponent,
    ReminderCreateComponent,
    BookingsFlowPopupComponent,
    PrimeListComponent,
    AddTodoTasksPopupComponent,
    MeetupCreateComponent,
    CreateRequestPopupComponent,
    AddContactPopupComponent,
    AmenitiesCreateComponent,
    GuestsEntryCreateComponent,
    FrontdeskRequestsCreateComponent
],
  templateUrl: './add-request-popup.component.html',
  providers: [DialogService, PaHttpClient, SpinnerService],
})
export class AddRequestPopupComponent implements OnInit {

  // ✅ Injected services for createTransaction
  private readonly http = inject(PaHttpClient);
  private readonly auth = inject(AuthService);
  private readonly spinner = inject(SpinnerService);
  private readonly toastr = inject(ToastrService);
  private readonly dialogService = inject(DialogService);
  private readonly workspaceMetrics = inject(WorkspaceMetricsService);
  readonly isRequest = input(false);
  requestList: IAddRequestOptions[] = requestOptions;
  closeAddReqPopup = output();
  requestComplete = output<any>();
  isCollabAddPopupVisible = false;
  readonly isBookingAddPopupVisible = signal(false);
  isAddReqVisible = true;
  readonly primeListComponent = viewChild(PrimeListComponent);
  readonly isAddTaskModalOpen = signal(false);
  readonly isAddReminderModalOpen = signal(false);
  readonly isAddAmenities = signal(false);
  readonly isAddGuestEntry = signal(false);
  readonly isAddFrontdesk = signal(false);
  readonly isAddMeetupOpen = signal(false);
  readonly isPaymentFlowOpen = signal(false);
  readonly selectedTransactionType = signal<{ value: string; label: string } | null>(null);
readonly isServiceOptionPopupVisible = signal(false);
readonly isPayRentFlow = signal(false);
readonly isAddContactOpen = signal(false);
readonly addContactType = signal<'personal' | 'business'>('personal');

  ngOnInit(): void {}

  closeAddReqDialog(): void {
    this.closeAddReqPopup.emit();
  }

  nextStep(step: string): void {
    switch (step) {
      case 'Collab':
        this.isCollabAddPopupVisible = true;
        this.isAddReqVisible = false;
        break;

      case 'Bookings':
        this.isBookingAddPopupVisible.set(true);
        this.isAddReqVisible = false;
        break;

      case 'To-Do Tasks':
        this.isAddTaskModalOpen.set(true);
        this.isAddReqVisible = false;
        break;

      case 'Meetup':
        this.isAddMeetupOpen.set(true);
        this.isAddReqVisible = false;
        break;

      case 'Add Transaction':
        this.selectedTransactionType.set({ value: 'send_payment', label: step });
        this.isPaymentFlowOpen.set(true);
        this.isAddReqVisible = false;
        break;

      case 'Add Reminders':
        this.isAddReminderModalOpen.set(true);
        this.isAddReqVisible = false;
        break;
      case 'Laundry':
        this.isServiceOptionPopupVisible.set(true);
        this.isAddReqVisible = false;
        break;
      case 'Schedule Amenities':
        this.isAddAmenities.set(true);
        this.isAddReqVisible= false;
        break;
      case 'Guest Entry':
        this.isAddGuestEntry.set(true);
        this.isAddReqVisible = false;
        break;
      case 'Front Desk':
        this.isAddFrontdesk.set(true);
        this.isAddReqVisible = false;
        break;
      case 'Pay Rent':
   this.isPayRentFlow.set(true); 
      this.selectedTransactionType.set({ value: 'one_time_payment', label: 'One-Time Payment' });
      this.isPaymentFlowOpen.set(true);
      this.isAddReqVisible = false;
  break;
      case 'Add Contacts':
        this.addContactType.set('personal');
        this.isAddContactOpen.set(true);
        this.isAddReqVisible = false;
        break;

      case 'Prime':
        this.isAddReqVisible = false;
        setTimeout(() => {
          this.primeListComponent()?.openCreatePrimeDialog(() => {
            this.closeAddReqDialog();
          });
        }, 50);
        break;
    }
  }

  onPrimeDialogClosed(): void {
    this.isAddReqVisible = true;
  }

  closeAddCollabPopup(e: any): void {
    if (e.collabCreated) {
      this.isCollabAddPopupVisible = false;
      this.closeAddReqDialog();
    } else {
      this.isCollabAddPopupVisible = false;
      this.isAddReqVisible = true;
    }
  }

  onBookingsFlowClose(event: any): void {
    this.isBookingAddPopupVisible.set(false);
    this.isAddReqVisible = true;
  }

  onBookingComplete(event: any): void {
    this.isBookingAddPopupVisible.set(false);
    this.closeAddReqDialog();
  }
  closeAmenitiesPopup(): void {
    this.isAddAmenities.set(false);
    this.closeAddReqDialog();
  }
  closeGuestEntryPopup(): void {
    this.isAddGuestEntry.set(false);
    this.closeAddReqDialog();
  }

  closeFrontdeskPopup(): void {
    this.isAddFrontdesk.set(false);
    this.closeAddReqDialog();
  }

 closeTodoPopup(): void {
    this.isAddTaskModalOpen.set(false);
    this.closeAddReqDialog();
  }
  closeMeetupPopup(): void {
    this.isAddMeetupOpen.set(false);
    this.closeAddReqDialog();
  }

  closeAddReminderModal(e: any): void {
    this.isAddReminderModalOpen.set(false);
    this.closeAddReqDialog();
  }


  onAddContactClose(e: any): void {
    this.isAddContactOpen.set(false);
    if (e?.refreshParent) {
      this.closeAddReqDialog();
    } else {
      this.isAddReqVisible = true;
    }
  }

  onServiceOptionClose(): void {
  this.isServiceOptionPopupVisible.set(false);
  this.isAddReqVisible = true;
}

onRequestComplete(event: any): void {
  this.isServiceOptionPopupVisible.set(false);
  this.closeAddReqDialog();
  this.requestComplete.emit(event);
}
onPaymentComplete(event: any): void {
  // this.isPaymentFlowOpen.set(false);
  if (this.isPayRentFlow()) {
    this.createPaymentTransaction(event); // ✅ Pay Rent API
  } else {
    this.createTransaction(event); // ✅ Transaction API
  }
}

onPaymentFlowClose(event: any): void {
  if (event?.close) {
    this.isPaymentFlowOpen.set(false);
    this.selectedTransactionType.set(null);
    this.isPayRentFlow.set(false); // ✅ Reset
    this.isAddReqVisible = true;
  }
}

createPaymentTransaction(paymentData?: any): void {
  const payee = paymentData?.payee;
  const payor = paymentData?.payor;
  const amount = paymentData?.amount;
  const unit = paymentData?.unit;
  const paymentMethod = paymentData?.paymentMethod;
  const paymentDate = paymentData?.paymentDate || new Date();

  if (!payee || !payor || !amount || !paymentMethod) return;

  this.spinner.showSpinner();

  const currentUser = this.auth.getUser();
  const currentUserId = String(currentUser?.user_id ?? '');

  const payeeId = payee.user_id || payee.contact_user_id || payee.contact_id;
  const payorId = payor.user_id || payor.contact_user_id || payor.contact_id;

  if (!payeeId) {
    this.toastr.showError('Payee ID is missing. Please select a valid payee.');
    this.spinner.hideSpinner();
    return;
  }
  if (!payorId) {
    this.toastr.showError('Payor ID is missing. Please select a valid payor.');
    this.spinner.hideSpinner();
    return;
  }
  if (!paymentMethod?.payment_method_id) {
    this.toastr.showError('Payment method is missing. Please select a payment method.');
    this.spinner.hideSpinner();
    return;
  }

  const payeeIdNum = Number(payeeId);
  const payorIdNum = Number(payorId);
  const paymentMethodIdNum = Number(paymentMethod.payment_method_id);
  const createdById = Number(currentUserId);

  if (isNaN(payeeIdNum) || isNaN(payorIdNum) || isNaN(paymentMethodIdNum) || isNaN(createdById)) {
    this.toastr.showError('Invalid ID format. Please try again.');
    this.spinner.hideSpinner();
    return;
  }

  const paymentDateObj = paymentDate instanceof Date ? paymentDate : new Date(paymentDate);
  const paymentDateStr = this.formatYmd(paymentDateObj);
  const pickupDateStr = paymentDateStr;
  const hours = String(paymentDateObj.getHours()).padStart(2, '0');
  const minutes = String(paymentDateObj.getMinutes()).padStart(2, '0');
  const seconds = String(paymentDateObj.getSeconds()).padStart(2, '0');
  const pickupTimeStr = `${hours}:${minutes}:${seconds}`;

  const payload: any = {
    created_by: String(createdById),
    status: 'paid',
    pickup_time: pickupTimeStr,
    payment_date: paymentDateStr,
    minimum_service_fee: '0.0',
    payment_method_id: String(paymentMethodIdNum),
    payee_user_id: payeeIdNum,
    service_sub_type: 'one_time_rent_payment',
    payment_type: 'monthly',
    pickup_date: pickupDateStr,
    payor_user_id: String(payorIdNum),
    unit: unit ? String(unit) : '',
    sales_tax: '0.0',
    tenant_id: String(payorIdNum),
    request_type: 'pay_rent',
    payment_transaction_id: '',
    payment_method: paymentMethod.payment_method_name || paymentMethod.name || 'Cash Payment',
    payment_estimate: String(Number(amount)),
    service_type: 'pay_rent',
    total_price: String(Number(amount)),
    notes: '',
  };

  this.http.post('request/add', payload).subscribe({
    next: (response: any) => {
      this.spinner.hideSpinner();
      this.isPayRentFlow.set(false);
      if (response.success) {
        this.workspaceMetrics.notifyCreated();
        this.isPaymentFlowOpen.set(false);
        this.openThankyouPopup('Pay Rent Processed', 'Your pay rent has been successfully processed.');
      } else {
        this.toastr.showError(response.message || 'Failed to process pay rent.');
      }
    },
    error: (error: any) => {
      this.spinner.hideSpinner();
      this.isPayRentFlow.set(false);
      this.toastr.showError(
        error?.error?.message || error?.message || 'An error occurred while processing pay rent.'
      );
    },
  });
}

// ✅ ADD helper — formatYmd needed by createPaymentTransaction
private formatYmd(date: Date): string {
  const y = date.getFullYear();
  const m = `${date.getMonth() + 1}`.padStart(2, '0');
  const d = `${date.getDate()}`.padStart(2, '0');
  return `${y}-${m}-${d}`;
}


  createTransaction(paymentData?: any): void {
    const payee = paymentData?.payee;
    const payor = paymentData?.payor;
    const amount = paymentData?.amount;
    const unit = paymentData?.unit;
    const paymentMethod = paymentData?.paymentMethod;
    const transactionTypeFromSelection = this.selectedTransactionType();
    const paymentDate = paymentData?.paymentDate || new Date();

    if (!payee || !payor || !amount) return;

    this.spinner.showSpinner();

    const currentUser = this.auth.getUser();
    const currentUserId = String(currentUser?.user_id ?? '');

    const payeeId = payee.user_id || payee.contact_user_id || payee.contact_id;
    const payorId = payor.user_id || payor.contact_user_id || payor.contact_id;

    if (!payeeId) {
      this.toastr.showError('Payee ID is missing. Please select a valid payee.');
      this.spinner.hideSpinner();
      return;
    }
    if (!payorId) {
      this.toastr.showError('Payor ID is missing. Please select a valid payor.');
      this.spinner.hideSpinner();
      return;
    }

    const payeeIdNum = Number(payeeId);
    const payorIdNum = Number(payorId);
    const addedById = Number(currentUserId);

    if (isNaN(payeeIdNum) || isNaN(payorIdNum) || isNaN(addedById)) {
      this.toastr.showError('Invalid ID format. Please try again.');
      this.spinner.hideSpinner();
      return;
    }

    const paymentDateObj = paymentDate instanceof Date ? paymentDate : new Date(paymentDate);
    const paymentDateTimeStr = paymentDateObj.toISOString();

    // ✅ Resolve transaction type
    const rawType = transactionTypeFromSelection;
    let transactionType: string =
      typeof rawType === 'string' ? rawType : (rawType?.value ?? 'send_payment');

    const allowedTypes = [
      'one_time_payment', 'scheduled_payment', 'send_payment',
      'request_payment', 'acknowledge_reciept', 'donation_payment',
    ];
    if (!allowedTypes.includes(transactionType)) {
      transactionType = 'send_payment';
    }

    // ✅ Map unit
    let unitValue: string | undefined;
    if (unit) {
      const unitLower = unit.toLowerCase().trim();
      const allowedUnits = [
        'per_item', 'per_service', 'per_hour', 'per_day',
        'per_month', 'packge', 'others',
      ];
      if (allowedUnits.includes(unitLower)) unitValue = unitLower;
      else if (unitLower.includes('service')) unitValue = 'per_service';
      else if (unitLower.includes('hour')) unitValue = 'per_hour';
      else if (unitLower.includes('day')) unitValue = 'per_day';
      else if (unitLower.includes('month')) unitValue = 'per_month';
      else if (unitLower.includes('package') || unitLower.includes('packge')) unitValue = 'packge';
      else unitValue = 'others';
    }

    // ✅ Generate transaction name
    const getContactName = (c: any): string => {
      if (!c) return 'N/A';
      if (c.management_name) return c.management_name;
      if (c.service_provider_name) return c.service_provider_name;
      return `${c.first_name || ''} ${c.last_name || ''}`.trim() || 'N/A';
    };

    let transactionName = paymentData?.transaction_name?.trim();
    if (!transactionName) {
      transactionName = `Payment from ${getContactName(payor)} to ${getContactName(payee)}`;
    }

    // ✅ Build payload
    const payload: any = {
      transaction_type: transactionType,
      payor_id: payorIdNum,
      payee_id: payeeIdNum,
      amount: Number(amount),
      transaction_name: transactionName,
      payment_date_time: paymentDateTimeStr,
      added_by: addedById,
    };

    if (unitValue) payload.units = unitValue;

    if (paymentData?.transaction_description?.trim()) {
      payload.transaction_description = paymentData.transaction_description.trim();
    }

    if (paymentMethod?.payment_method_id) {
      const pmId = Number(paymentMethod.payment_method_id);
      if (!isNaN(pmId)) payload.payment_method_id = pmId;
    }

    if (paymentData?.currency) {
      payload.currency = paymentData.currency;
    }

    if (transactionType === 'donation_payment') {
      // if (paymentData?.fundraise_id) {
        // const fId = Number(paymentData.fundraise_id);
      //   if (!isNaN(fId)) {
      //     payload.fundraise_id = fId;
      //   } else {
      //     this.toastr.showError('Fundraise ID is required for donation payments.');
      //     this.spinner.hideSpinner();
      //     return;
      //   }
      // } else {
      //   this.toastr.showError('Fundraise ID is required for donation payments.');
      //   this.spinner.hideSpinner();
      //   return;
      // }
    }

    // ✅ Submit
    const images: File[] = Array.isArray(paymentData?.images) ? paymentData.images : [];
    const requestBody: any = images.length ? this.buildTransactionFormData(payload, images) : payload;

    this.http.post('payments/create_transaction', requestBody).subscribe({
      next: (response: any) => {
        this.spinner.hideSpinner();
        this.selectedTransactionType.set(null);
        if (response.success) {
          this.workspaceMetrics.notifyCreated();
          this.isPaymentFlowOpen.set(false);
          this.openThankyouPopup();
        } else {
          this.toastr.showError(response.message || 'Failed to process transaction.');
        }
      },
      error: (error: any) => {
        this.spinner.hideSpinner();
        this.selectedTransactionType.set(null);
        this.toastr.showError(getApiErrorMessage(error, 'An error occurred while processing transaction.'));
      },
    });
  }

  private buildTransactionFormData(payload: Record<string, any>, images: File[]): FormData {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });
    images.forEach((img: File) => formData.append('images', img));
    return formData;
  }

 private openThankyouPopup(
  title = 'Transaction Processed',
  p1 = 'Your transaction has been successfully processed.'
): void {
  const dialogRef = this.dialogService.open(ThankyouPopupComponent, {
    width: '480px',
    showHeader: false,
    modal: true,
    styleClass: 'p-0 !border-0',
    contentStyle: { padding: '0' },
    data: {
      title,
      p1,
      p2: 'Please check your notifications for the latest updates.',
      p3: 'Thank you!',
    },
  });

  dialogRef?.onClose.subscribe(() => {
    this.closeAddReqDialog();
  });
}
}